<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-header">
        <h5 class="text-center">MIS EMPRESAS</h5>
      </div>
      <div class="card-body">
        <div class="col-12 col-md-3 P-3">
           <!-- <a
            href="#"
            class="btn btn-success"
            @click="amEmpresa(undefined)"
            aria-pressed="true"
            ><i class="fa fa-plus"></i
          ><small> Nueva Empresa</small></a>  -->
          <RouterLink
                  class="btn btn-success "
                  :to="{
                    path: `/empresa/NuevoEmpresa`,
                  }"
                  ><small> Nueva Empresa</small>
                </RouterLink>
        </div><br>
        <div class="text-center" v-if="cargando">
          <i class="fa fa-spinner fa-pulse fa-5x"></i>
          <h4 class="mt-2">Cargando Datos...</h4>
        </div>
        <div class="table-responsive" style="overflow-y:scroll; height:360px;">
          <table class="table table-striped table-bordered" v-if="!cargando && empresas.length > 0">
            <thead>
              <tr class="text-center">
                <th><small class="font-weight-bold">NRO.</small></th>
                <th><small class="font-weight-bold">RAZÓN SOCIAL</small></th>
                <th><small class="font-weight-bold">DIRECCIÓN</small></th>
                <th><small class="font-weight-bold">RUBRO</small></th>
                <th><small class="font-weight-bold">ESTADO</small></th>
                <th><small class="font-weight-bold">ACCIONES</small></th>
              </tr>
            </thead> 
            <tbody>
              <tr v-for="(item, index) in empresas" :key="index">
                <td class="text-center">
                  <small>{{ index + 1 }}</small>
                </td>
                <td>
                  <small>{{ item.emp_razon_social }}</small>
                </td>
                <td>
                  <small>{{ item.emp_direccion }}</small><br>
                  <small class="text-muted">{{ item.nombre_departamento + " - " + item.nombre_municipio }}</small>
                </td>
                <td>
                  <small>{{ item.rubro_descripcion }}</small>
                </td>
                <td class="text-center">
                  <span v-if="item.estado_proceso==1" class="badge badge-success"> ACTIVO</span>
                  <span v-else class=" badge badge-danger">INACTIVO</span>
                </td>
                <td class="text-center">
                  <!--rubro-->
                  <!--1-->
                  <router-link v-if="item.id_rubro == 1 && item.estado_registro == 1"
                    class="btn btn-outline-info btn-sm mr-2"
                    :to="{ name: 'partesAereo', params: { item: item } }"
                    title="Ingresa Manifiesto">
                    <i class="fa fa-plane"></i>
                  </router-link> 
                  <!--2-->
                  <router-link v-if="item.id_rubro == 2"
                    class="btn btn-outline-info btn-sm mr-2"
                    :to="{ name: 'partesTerrestres', params: { item: item } }"
                    title="Subir Partes Terrestres">
                    <i class="fa fa-car"></i>
                  </router-link> 
                  <!--3-->
                  <!-- <router-link v-if="item.id_rubro == 3"
                    class="btn btn-outline-info btn-sm mr-2"
                    :to="{ name: 'centroHospedaje', params: { item: item } }"
                    title="Ingresar Centro Hospedaje">
                    <i class="fa fa-check-square-o"></i>
                  </router-link> -->
                  <router-link v-if="item.id_rubro == 3"
                    class="btn btn-outline-info btn-sm mr-2"
                    :to="{ name: 'partesHospedaje', params: { item: item } }"
                    title="Ingresar Centro Hospedaje">
                    <i class="fa fa-user-circle"></i>
                  </router-link>

                  <!--4-->
                  <router-link v-if="item.id_rubro == 4"
                    class="btn btn-outline-info btn-sm mr-2"
                    :to="{ name: 'partesAgencia', params: { item: item } }"
                    title="Subir Partes Agencias">
                    <i class="fa fa-train"></i>
                  </router-link> 
                  <!--5-->
                  <router-link v-if="item.id_rubro == 5"
                    class="btn btn-outline-info btn-sm mr-2"
                    :to="{ name: 'partesInstituciones', params: { item: item } }"
                    title="Subir Partes Instituciones">
                    <i class="fa fa-university"></i>
                  </router-link> 
                  <!--6-->
                  <router-link v-if="item.id_rubro == 6"
                    class="btn btn-outline-info btn-sm mr-2"
                    :to="{ name: 'partesNocturnas', params: { item: item } }"
                    title="Subir Partes Clubes Nocturnas">
                    <i class="fa fa-list-alt"></i>
                  </router-link> 
                    <router-link
                    v-if="item.estado_registro == 1"
                  class="btn btn-outline-warning btn-sm mr-1"
                    title="Editar Registro"
                  :to="{
                    path: `/empresa/EditarEmpresa/${item.id_empresa}`,
                  }"
                  >
                  <i class="fa fa-edit"></i>
                </router-link>
                  <!-- <a v-if="item.estado_registro == 1" 
                    class="btn btn-outline-warning btn-sm mr-1"
                    title="Editar Registro"
                    @click="amEmpresa(item)"
                  >
                    <i class="fa fa-edit"></i>
                  </a> -->
                  <a v-if="item.estado_proceso == 1"
                    class="btn btn-outline-danger btn-sm"
                    title="Baja Registro"
                    @click="bajaEmpresa(item)"
                    ><i class="fa fa-trash"></i></a>
                  <a v-if="item.estado_proceso == 0"
                    class="btn btn-outline-success btn-sm"
                    title="Alta Registro"
                    @click="altaEmpresa(item)"
                    ><i class="fa fa-check"></i>
                  </a>

                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal
      class="modal fade"
      size="xl"
      hide-footer
      title="EMPRESA"
      ref="modalEmpresas"
      :no-close-on-backdrop="true"
    >
      <!-- <div class="modal-dialog modal-lg"> -->
      <div class="container mb-3">
          <div class="card">
            <div class="card-header">
              <h6 class="text-center">{{ tituloModal }}</h6>
            </div>
              <div class="card-body">   
              <div class="row">
                <div class="col-md-4">

                  <div class="row form-group">
                    <div class="col-12 col-md-12">
                      <label class="font-weight-bold mr-1">Razón Social:</label>
                      <span
                        class="text-danger text-help"
                        v-if="!$v.empresa.emp_razon_social.required"
                        ><small>Campo requerido</small>
                      </span>
                      <input
                        type="text"
                        placeholder="Ej.: Hotel Girasoles"
                        class="form form-control"
                        :class="{'is-invalid': $v.empresa.emp_razon_social.$error}"
                        v-model.trim="empresa.emp_razon_social"
                        @keyup="empresa.emp_razon_social = empresa.emp_razon_social.toUpperCase()"
                      />
                   </div> 
                  </div>
              
                  <div class="row form-group">  
                    <div class="col-12 col-md-12" >
                      <label class="font-weight-bold mr-1">Nit:</label>
                        <span
                          class="text-danger text-help"
                          v-if="!$v.empresa.emp_nit.required"
                          ><small>Campo requerido</small>
                        </span>
                        <input
                          type="number"
                          placeholder="Ej.: 82938445"
                          class="form form-control"
                          :class="{'is-invalid':$v.empresa.emp_nit.$error }"
                          v-model="empresa.emp_nit"
                        />
                    </div>
                  </div>
                  <div class="row form-group">  
                    <div class="col-12 col-md-12" >
                       <label class="font-weight-bold mr-1">Licencia Funcionamiento:</label>
                          <span
                            class="text-danger text-help"
                            v-if="!$v.empresa.emp_licencia.required"
                            ><small>Campo requerido</small>
                          </span>
                          <input
                            type="number"
                            
                            placeholder="Ej.: 82938445"
                            class="form form-control"
                            :class="{'is-invalid':$v.empresa.emp_licencia.$error}"
                            v-model="empresa.emp_licencia"/>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-12 col-md-12">
                      <label class="font-weight-bold mr-1">Teléfono:</label>
                        <span
                          class="text-danger text-help"
                          v-if="!$v.empresa.emp_telefono.required"
                          ><small>Campo requerido</small>
                        </span>
                        <input
                          type="number"
                          placeholder="Ej.: 82938445"
                          class="form form-control"
                          :class="{'is-invalid':$v.empresa.emp_telefono.$error}"
                          v-model="empresa.emp_telefono"/>
                    </div>
                  </div>
                  <div class="row form-group">
                     <div class="col-12 col-md-12">
                      <label class="font-weight-bold mr-1">Rubro:</label>
                      <span
                        class="text-danger text-help"
                        v-if="!$v.empresa.id_rubro.required"
                        ><small>Campo requerido</small>
                      </span>
                      <select
                        class="custom-select"
                        :class="{ 'is-invalid':$v.empresa.id_rubro.$error }"
                        v-model="empresa.id_rubro"
                      >
                        <option value="">SELECCIONAR</option>
                        <option
                          v-for="t in rubros"
                          :value="t.id_rubro"
                          :key="t.rubro_descripcion"
                          >{{ t.rubro_descripcion }}</option
                        >
                      </select>
                    </div>     
                  </div>
                  <div class="row form-group">
                       <div class="col-12 col-md-12">
                          <label class="font-weight-bold mr-1"> Tipo Servicio: </label>
                          <span
                            class="text-danger text-help"
                            v-if="!$v.empresa.tipo_servicio.required"
                            ><small>Campo requerido</small>
                          </span>
                          <select 
                            class="form form-control"
                            :class="{ 'is-invalid':$v.empresa.tipo_servicio.$error }"
                            v-model="empresa.tipo_servicio"
                          >
                            <option value="">SELECCIONAR</option>
                            <option value="SERVICIO">SERVICIOS BRINDADOS</option>
                            <option value="CONTRATO">PERSONAL CONTRATADO</option>
                          </select>
                        </div>
                  </div>
                </div>

                <div class="col-md-8">
                 <div class="row form-group">
                    <div class="col-12 col-md-4">
                      <label class="font-weight-bold mr-1">Departamento:</label>
                        <span
                          class="text-danger text-help"
                          :class="{'is-invalid': $v.empresa.codigo_departamento.$error}"
                          v-if="!$v.empresa.codigo_departamento.required"
                          ><small>Requerido</small>
                        </span>
                        <select
                          class="custom-select"
                          :class="{'is-invalid':$v.empresa.codigo_departamento.$error}"
                          v-model="empresa.codigo_departamento"
                          @change="getMunicipios(empresa.codigo_departamento)"
                        >
                       
                          <option v-for="(item, index) in departamentos" :value="item.codigo_departamento" :key="index">{{ item.nombre_departamento }}</option>
                        </select>
                    </div>
                  
                    <div class="col-12 col-md-4">
                      <label class="font-weight-bold mr-1">Municipio:</label>
                          <span
                            class="text-danger text-help"
                            v-if="!$v.empresa.id_municipio.required"
                            ><small>Campo requerido</small>
                          </span>
                          <select
                            class="custom-select"
                            :class="{'is-invalid':$v.empresa.id_municipio.$error}"
                            v-model="empresa.id_municipio"
                          >
                          <option value="">SELECCIONAR</option>
                            <option
                              v-for="t in municipios"
                              :value="t.id_municipio"
                              :key="t.nombre_municipio"
                              >{{ t.nombre_municipio }}</option
                            >
                          </select>
                    </div>
                 
                    <div class="col-12 col-md-4">
                      <label class="font-weight-bold mr-1">Dirección:</label>
                        <span
                          class="text-danger text-help"
                          v-if="!$v.empresa.emp_direccion.required"
                          ><small>requerido</small>
                        </span>
                        <input
                          type="text"
                          placeholder="Ej.: Av. Ejercito"
                          class="form form-control"
                          :class="{'is-invalid':$v.empresa.emp_direccion.$error}"
                          v-model.trim="empresa.emp_direccion"
                          @keyup="empresa.emp_direccion = empresa.emp_direccion.toUpperCase()"
                        />
                    </div>                   
                  </div>

                  <div class="row">
                    <div class="col-12 col-md-12 form-group">
                      <label class="mr-1">Fotografía del frontis de la empresa:</label><br>  
                      <input type="file" id="file" ref="file" accept="image/*" @change="uploadImage($event)">
                    </div>
                    <div class="mx-auto text-center img-responsive">
                      <output id="list"></output>
                    </div>
                   
                  </div>
                      <div class="mx-auto text-center" v-if="!controBoton">
                      <output id="list"></output>
                      <img 
                        class="img-thumbnail text-center" 
                        width="275px" 
                        height="188px"
                        :src="'data:'+imagen.content+';base64,'+imagen.base64">
                    </div>
                  <div class="row form-group">
                      <div class="col-12 col-md-12">
                     
                     
                          <!-- <GoogleMap 
                            :title="'Esta es mi residencia'" 
                            :lat="empresa.emp_latitud" 
                            :lng="empresa.emp_longitud" 
                            :departamento="departamento" 
                            style="width: 100%; height: 360px"  
                            @coordenadas="capturaCoordenadas"
                          />

                          <small>{{empresa.emp_latitud}} - {{empresa.emp_longitud}}</small> -->

                       </div> 
                  </div>
                </div>
              </div>

              <div class="row ">
                <div class="col-md-4"></div>
                <div class="col-12 col-md-4"> 
                  <button @click="hideModal()" class="btn btn-secondary btn-block">
                  Cancelar
                  </button>
                </div>
                <div class="col-12 col-md-4" v-if="controBoton"> 
                  <button @click="crearEmpresa()" class="btn btn-primary btn-block">Registrar</button>
                </div>
                <div class="col-12 col-md-4" v-if="!controBoton"> 
                  <button @click="updateEmpresa()" class="btn btn-primary btn-block">Actualizar</button>
                </div>
              </div>
            <!-- </form> -->
            </div>
          </div>
         
        </div>
      <!-- </div> -->
    </b-modal>
    <Loading v-show="cargando" />
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import Loading from "../../components/Loading";
//import moment from "moment";
//import GoogleMap from "../../components/GoogleMap";


export default {
  name: "empresas",
  data() {
    return {
      

      empresas: [],
      empresa: {
        departamento: 'LPG',
        emp_latitud: 0,
        emp_longitud: 0,
        id_municipio:'',
      },
      cargando: false,
      tituloModal: "Registro Empresa",
      departamentos: [],
      disabledHos: 1,
      disabledRes: 0,
      disabledND: 0,
      imagen: {
        base64: '',
        content: ''
      },
      municipios: [],
      rubros: [],
      
      persona: {},
      controBoton: true,
      departamento: ''
      //submitted: false,
    };
  },
  components: {
    Loading,
    //GoogleMap
   
  },
  methods: {
    
    async amEmpresa(item) {
      this.getDepartamentos();
      if (item == undefined) {
        this.empresa = {};
        // Valores por defecto
        this.empresa.codigo_departamento = 'LPG';
        this.getMunicipios('LPG');
        this.empresa.emp_latitud = -16.5157398;
        this.empresa.emp_longitud = -68.1257891;
        this.tituloModal = "NUEVO REGISTRO";
        this.controBoton = true;
      } else {
        // Arreglo para departamento
        let departamento = item.codigo_departamento;
        switch(departamento){
          case 'LPG':
            this.departamento = 'LA PAZ';
          break;
          case 'CBD':
            this.departamento = 'COCHABAMBA';
          break;
          case 'SCD':
            this.departamento = 'SANTA CRUZ';
          break;
          case 'ORD':
            this.departamento = 'ORURO';
          break;
          case 'PTD':
            this.departamento = 'POTOSI';
          break;
          case 'TJD':
            this.departamento = 'TARIJA';
          break;
          case 'CHD':
            this.departamento = 'CHUQUISACA';
          break;
          case 'BND':
            this.departamento = 'BENI';
          break;
          case 'PND':
            this.departamento = 'PANDO';
          break;
          default:
            this.departamento = 'LA PAZ'; 
          break;
        }

        this.empresa = item;
        this.empresa.emp_direccion;
        //carga ubicacion
        this.empresa.emp_latitud = Number(item.emp_latitud);
        this.empresa.emp_longitud = Number(item.emp_longitud);
        // Carga Imagen
        let imagen = item.nombre_imagen;
        let rutaImg  = await this.axios.get(`/imagenMostrar/frontis/${imagen}`);
        this.imagen.base64 = rutaImg.data.imagen;
        this.imagen.content = rutaImg.data.content;
        this.tituloModal = "EDITAR REGISTRO";
        this.controBoton = false;

        this.getMunicipios(this.empresa.codigo_departamento);
      }

      this.showModal();
    },
    async getDepartamentos() {
      try {
        let resultados = await this.axios.get(`/getDepartamentos`);
        this.departamentos = resultados.data.contenido;
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async getMunicipios(par_cod_depto) {
      try {
        let resultados = await this.axios.get(`/getMunicipio/${par_cod_depto}`);
        this.municipios = resultados.data.contenido;
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async getRubros() {
      try {
        let resultados = await this.axios.get(`/getRubros`);
        this.rubros = resultados.data.contenido;
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async getEmpresas(id_persona) {
      try {
        let resultados = await this.axios.get(`/empresas/${id_persona}`);
        this.empresas = resultados.data.contenido;
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async crearEmpresa() {
      this.cargando = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.cargando = false;
        return;
      }

 

      this.empresa.id_persona = this.persona.id_persona;
      
      try {

        let empresa = await this.axios.get(`/empresa/verificaEmpresa/${this.empresa.emp_nit}/${this.empresa.emp_licencia}/${this.empresa.emp_razon_social}`);
        if(empresa.status == 200){
          let verifica = empresa.data.contenido[0]._verifica_empresas;
          if(verifica == 1){
            this.cargando = false;
            this.$swal({
              title: 'Información',
              html: `<b>${this.empresa.emp_razon_social}</b> registrada anteriormente.`,
              type: 'info',
              confirmButtonText: 'Aceptar'
            });
            this.empresa.emp_nit = '';
            this.empresa.emp_licencia = '';
            this.empresa.emp_razon_social = '';
            return;
          }
        }

        let resultados = await this.axios.post(`/empresa`, this.empresa);
        let id = resultados.data.contenido.id_empresa;

        let config = {        
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        let formData = new FormData();
        formData.append('archivo', this.file);

        let res = await this.axios.put(`/upload/frontis/${id}`, formData, config);
        if (res.status === 200) {
          this.cargando = false;
          this.$swal({
            title: 'Información',
            html: 'Empresa adicionada correctamente.',
            type: 'success',
            confirmButtonText: 'Aceptar'
          })
          .then((error)=>{
            if(error.value){
              this.$router.push('empresas');
            }
          });
         
        }
     
        this.hideModal();
        this.getEmpresas(this.empresa.id_persona);

      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async updateEmpresa() {
      //this.empresa.emp_latitud = "0";
      //this.empresa.emp_longitud = "0";
      this.empresa.estado_registro = 1;

      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.cargando = false;
        return;
      }

      this.empresa.id_persona = this.persona.id_persona;

      try {
        let resultados = await this.axios.put(`/empresa`, this.empresa);
        this.empresa = resultados.data.contenido;
        let id = resultados.data.contenido.id_empresa;
       // this.empresa.emp_latitud = Number(this.resultados.emp_latitud);
        //this.empresa.emp_longitud = Number(this.resultados.emp_longitud);

        let config = {        
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        let formData = new FormData();
        formData.append('archivo', this.file);

        let res = await this.axios.put(`/upload/frontis/${id}`, formData, config);
        if (res.status === 200) {
          this.$swal({
            title: 'Información',
            html: 'Empresa adicionada correctamente.',
            type: 'success',
            confirmButtonText: 'Aceptar'
          })
          .then((error)=>{
            if(error.value){
              this.$router.push('empresas');
            }
          });
         
        }
       
        this.$swal({
          title: 'Información',
          text: 'Se Actualizo Correctamente!',
          type: 'success',
          confirmButtonText: 'Aceptar'
        });

        this.hideModal();
        this.getEmpresas(this.empresa.id_persona);
      } catch (error) {
        console.log('catch: ', error);
      }


    },
    async listarDato() {
      let config = { headers: { token: this.token } };
      try {
        this.resultados = await this.axios.get(`/personaGetDataLogin`, config);
        this.persona = this.resultados.data.contenido;
        this.getEmpresas(this.persona.id_persona);
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    bajaEmpresa(empresa) {
      this.$swal({
        title: "Esta Seguro?",
        html: "De realizar la <b>baja</b> de la Empresa.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Realizar Baja",
      })
      .then(async (result) => {
        if (result.value) {
          try {
            await this.axios.patch(`/empresa/baja`, empresa);
            this.getEmpresas(empresa.id_persona);
            this.$swal({
              title: 'Información',
              text: 'Se dio de Baja.',
              type: 'success',
              confirmButtonText: 'Aceptar'
            });
          } catch (error) {
            console.log(error);
          }
        }
      });


    },

    capturaCoordenadas (value){
     // console.log(value);
      this.empresa.emp_latitud= value.lat;
      this.empresa.emp_longitud= value.lng;
    },
  
    setPlace(event){
      //console.log(event);
      this.empresa.emp_latitud= event.geometry.location.lat();
      this.empresa.emp_longitud= event.geometry.location.lng(); 
      this.empresa.codigo_departamento = (event.address_components[3].long_name).toUpperCase() ;
    },

    async obtenerLugar (){
      await this.posicionNavegador();
    },
    posicionNavegador (){
      if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function(position) {
            let pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            //console.log('esta', pos);  
            return pos;   
          }, function() {
              //handleLocationError(true, infoWindow, map.getCenter());
          });
      } else {
          // Browser doesn't support Geolocation
          //handleLocationError(false, infoWindow, map.getCenter());
      }
    },
    altaEmpresa(empresa) {
      this.$swal({
        title: "Estas Seguro?",
        text: "Daras de alta a la Empresa!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, dar de Alta!",
      })
      .then(async (result) => {
        if (result.value) {
          try {
            await this.axios.put(`/empresa/alta`, empresa);
            this.$swal({
              title: 'Información',
              text: 'Se dio de Alta.',
              type: 'success',
              confirmButtonText: 'Aceptar'
            });
            this.getEmpresas(empresa.id_persona);
          } catch (error) {
            console.log('catch: ', error);
          }
        }
      });
    },

    uploadImage (evt){
      this.file = this.$refs.file.files[0];

      let files = evt.target.files; 
      for (let i = 0; i < files.length; i++) {
        let f = files[i];
        if (!f.type.match('image.*')) {
            continue;
        }
        let reader = new FileReader();
        reader.onload = (function(theFile) {
            return function(e) {
            document.getElementById("list").innerHTML = ['<img class="img-responsive img-thumbnail text-center" width="350px" height="250px" src="', e.target.result,'" title="', escape(theFile.name), '"/>'].join('');
            };
        })(f);
        reader.readAsDataURL(f);
      }
    },
    showModal() {
      this.empresa.id_rubro = '';
      this.empresa.tipo_servicio = '';
      this.empresa.id_municipio = '';
      this.$refs["modalEmpresas"].show();
    },
    hideModal() {
      this.$refs["modalEmpresas"].hide();
    },
  },

  async onChangeEmpresa(event){
      try {
        this.empresa.id_empresa = event.target.options[event.target.selectedIndex].value;
        this.empresa.nombre_empresa = (event.target.options[event.target.selectedIndex].text).split(' - ')[0];
        
        let resultado = await this.axios.get(`/getEmpresaDescripcion/${this.empresa.id_empresa}`);
        let datoEmpresa = resultado.data.contenido[0];
        
        // Carga Mapa
        this.empresa.direccion = datoEmpresa.emp_direccion;
        this.empresa.telefono = datoEmpresa.emp_telefono
        this.empresa.latitud = Number(datoEmpresa.emp_latitud);
        this.empresa.longitud = Number(datoEmpresa.emp_longitud);
        // Carga Imagen
        let imagen = datoEmpresa.nombre_imagen;
        let rutaImg  = await this.axios.get(`/imagenMostrar/frontis/${imagen}`);
        this.imagen.base64 = rutaImg.data.imagen;
        this.imagen.content = rutaImg.data.content;

      } catch (error) {
        console.log('catch: ', error);
      }
    },
    async onLoadImageDefault(){
      let rutaImg  = await this.axios.get(`/imagenMostrar/f/default`);
      this.imagen.base64 = rutaImg.data.imagen;
      this.imagen.content = rutaImg.data.content;
    },

  created() {
    this.listarDato();
    //this.getDepartamentos();
    this.getRubros();
  },
  validations: {
    empresa: {
      emp_razon_social: { required },
      emp_nit: { required },
      emp_licencia: { required },
      emp_telefono: { required },
      codigo_departamento: { required },
      id_municipio: { required },
      emp_direccion: { required },
      id_rubro: { required },
      tipo_servicio: { required },
      emp_latitud: { required },
      emp_longitud: { required }
    },
  },
};
</script>
